import { useQueryClient } from 'react-query';

import { useApiMutation } from '../../api/useApi';

import { marquerConversationNonLue } from './useConversations';

/**
 * Remettre une conversation en non lu — #86.
 *
 * Le geste lui-même : `PUT /customers/{id}/mark-unread`. Tout ce qui protège le
 * résultat côté cache — annuler le poll de `/get-messages` en vol, patcher la
 * liste — vit dans `marquerConversationNonLue`, testable seule avec un vrai
 * `QueryClient`. Ce hook ne fait que la brancher en `onSuccess` de la mutation.
 *
 * L'appelant (`FilConversation`) referme le fil vers la liste sur ce succès :
 * c'est ce retour, pas un `removeQueries` ici, qui arrête pour de bon le poll de
 * 30 s — un `removeQueries` pendant que l'écran est encore monté risquerait de
 * relancer un fetch immédiat sur l'observateur toujours abonné.
 */
export function useMarquerNonLu(customerId: string) {
    const queryClient = useQueryClient();

    return useApiMutation<unknown, unknown, void>(
        'put',
        () => `/customers/${customerId}/mark-unread`,
        { onSuccess: () => marquerConversationNonLue(queryClient, customerId) },
    );
}
